import SelectOnboardingContainer from './select_onboarding_container';

const SelectOnboarding = SelectOnboardingContainer;
export default SelectOnboarding;
